/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ExtractHistoryHack } from 'businessLogic/historyHack';
import { loadFromStorage } from 'businessLogic/localStorage';
import Auth0Redirect from 'components/Auth/Auth0Redirect';
import ForgotPassword from 'components/Auth/ForgotPassword';
import Logout from 'components/Auth/Logout';
import ResetPassword from 'components/Auth/ResetPassword';
import SSOLogin from "components/Auth/SSOLogin";
import AppContainer from 'containers/AppContainer';
import { once } from "lodash";
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { CookieGroups } from "typedefs/onetrust";
import { Logger } from '../../src/app/services';
import Auth0Unauthorized from './Unauthorized/Auth0Unauthorized';

const { userId, token } = loadFromStorage();

export interface Props {
  configData: any;
  userEmail: string;
  setConfigFromPage: (config: any) => void;
  setUserToken: (id: number | void, token: string | void) => void;
  ejectUser: () => void;
  fetchFeatures: () => Promise<void>;
}

class Root extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.configureOnetrust();
    props.setConfigFromPage(props.configData);
    props.fetchFeatures();

    if (userId && token) {
      props.setUserToken(userId, token);
    }
  }

  configureOnetrust = () => {
    window.OptanonWrapper = () => {
      const activeGroups = (window?.OptanonActiveGroups?.split(',') || []) as CookieGroups[];
      if (activeGroups.indexOf("C0002") > -1) {
        //prevent logging from being re-initialized if opting back in
        this.configureLogging();
      }
    };
  }

  configureLogging = once(() => {
    const envName = window.CONFIG?.config.releaseStage || this.props.configData.releaseStage;
    if (envName === 'prod' || envName === 'demo') {
      Logger.init(this.props.configData);
    }
  });

  render() {

    return (
      <React.Fragment>
        <ExtractHistoryHack />
        <Switch>
            <Route exact={true} path="/auth0/login" render={() => (
              <Auth0Redirect {...this.props} />
            )} />
            <Route exact={true} path="/auth0/login/success" component={SSOLogin} />
            <Route
              exact={true}
              path="/logout"
              render={(): JSX.Element => (
                <Logout
                  ejectUser={this.props.ejectUser}
                  logoutUrl={this.props.configData.auth0.logoutUrl}
                />
              )}
            />
            <Route exact={true} path="/auth0/unauthorized" component={Auth0Unauthorized} />
            <Route exact={true} path="/password/email" component={ForgotPassword} />
            <Route path="/password/reset/:hash" component={ResetPassword} />
            <Route exact={true} path="/" component={AppContainer} />
            <Route path="/chat" component={AppContainer} />
            <Route path="/admin" component={AppContainer} />

            {/* legacy routes */}
            <Redirect from="/billingreport" to="/admin/report/call-center-billing" />
          </Switch>
      </React.Fragment>
    );
  }
}

export default Root;
